import Privilege from './privilege'
export default Privilege